/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { cx } from '@emotion/css';
import FinderPattern from './components/form/FinderPattern/FinderPattern';
import CodePattern from './components/form/CodePattern/CodePattern';
import Color from './components/form/Color/Color';
import CenterLogo from './components/form/CenterLogo/CenterLogo';
import BackgroundImage from './components/form/BackgroundImage/BackgroundImage';
import { QrCodeCustomizationsFormStyles } from './QrCodeCustomizationsForm.styles';
import { useGetChildrenProps } from './hooks/useGetChildrenProps/useGetChildrenProps';
export const QrCodeCustomizationsForm = (props) => {
    const getChildrenProps = useGetChildrenProps(props);
    const { id, className, hideFinderPattern, hideCodePattern, hideColor, hideCenterLogo, hideBackgroundImage, } = props;
    return (React.createElement("div", { className: cx(QrCodeCustomizationsFormStyles.container, className), id: id }, props.children ? (React.Children.map(props.children, (child) => {
        return React.cloneElement(child, Object.assign(Object.assign({}, getChildrenProps(child.props.instanceOf)), child.props));
    })) : (React.createElement(React.Fragment, null,
        !hideFinderPattern && (React.createElement(FinderPattern, Object.assign({}, getChildrenProps('FinderPattern')))),
        !hideCodePattern && (React.createElement(CodePattern, Object.assign({}, getChildrenProps('CodePattern')))),
        !hideColor && React.createElement(Color, Object.assign({}, getChildrenProps('Color'))),
        !hideCenterLogo && (React.createElement(CenterLogo, Object.assign({}, getChildrenProps('CenterLogo')))),
        !hideBackgroundImage && (React.createElement(BackgroundImage, Object.assign({}, getChildrenProps('BackgroundImage'))))))));
};
QrCodeCustomizationsForm.FinderPattern = FinderPattern;
QrCodeCustomizationsForm.CodePattern = CodePattern;
QrCodeCustomizationsForm.Color = Color;
QrCodeCustomizationsForm.CenterLogo = CenterLogo;
QrCodeCustomizationsForm.BackgroundImage =
    BackgroundImage;
export default QrCodeCustomizationsForm;
//# sourceMappingURL=QrCodeCustomizationsForm.js.map